import { TransitRepository } from '../repositories/transit.repository'
import { TransitGetTTNSResponseT } from '../types/transit.types'

const transitRepository = new TransitRepository()

export class TransitService {
    async getTTNS(number: string): Promise<TransitGetTTNSResponseT> {
        const response = await transitRepository.getTTNS(number)
        return response.data
    }

    async setDeliveryDate(tripNumber: string, cityName: string): Promise<void> {
        await transitRepository.setDeliveryDate(tripNumber, cityName)
    }
}
